

























/** @format */

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { PLATE_PROVINCE_STRING } from './constant';

@Component
export default class PlateInputGroup extends Vue {
  plateProvinceList = PLATE_PROVINCE_STRING.split('');
  /**
   * 车牌号值
   */
  @Prop({ default: '' })
  value!: string;

  /**
   * 车牌号默认值
   */
  @Prop({ default: '' })
  defaultValue!: string;

  /**
   * 车牌号第一位是否可编辑
   */
  @Prop({ default: false })
  plateHeadDisabled!: boolean;

  /**
   * 是否需要传入其他值 会变成 plateChange 第二个值传出
   * 可为空
   */
  // @Prop({ default: () => {} })
  // params!: object

  plateHead: string = '';
  plateTail: string = '';
  plateHeadDefault: string = '';
  plateTailDefault: string = '';

  created() {
    this.initValue(this.value);
    this.onDefaultValueChange(this.defaultValue);
  }

  // 监听value值，初始化填入内容
  @Watch('value')
  initValue(newVal: string) {
    const [plateHead, plateTail] = this.validateAndSplitPlate(newVal);
    this.plateHead = plateHead;
    this.plateTail = plateTail;
  }

  // 省select修改值同步，同步父级+内部select空值placeholder处理
  plateHeadChange(newVal: string) {
    // const plateHead = this.validatePlateHead(newVal)
    const plateHead = (newVal || this.plateHeadDefault).toLocaleUpperCase();
    this.plateHead = plateHead;
    this.$emit('input', plateHead + this.plateTail, [plateHead, this.plateTail]);
    this.$emit('change', plateHead + this.plateTail, [plateHead, this.plateTail]);
  }

  @Watch('plateTail')
  plateTailChange(newVal: string, oldVal: string) {
    // const plateTail = this.validatePlateTail(newVal)
    // debugger
    // if (plateTail !== newVal) {
    //   // 校验并拆分粘贴进组件的数据
    //   const [plateHead, plateTail] = this.validateAndSplitPlate(newVal)
    //   this.plateTail = plateTail
    //   if (!this.plateHeadDisabled && plateHead) {
    //     // head可编辑且tail中有head值，则赋值
    //     this.plateHead = plateHead
    //   }
    // } else {
    // 直接对外input出去，有变动重走initValue方法，减少内部判断条件
    const plateTail = newVal;
    this.$emit('input', (this.plateHead + plateTail).toLocaleUpperCase(), [
      this.plateHead.toLocaleUpperCase(),
      plateTail
    ]);
    this.$emit('change', (this.plateHead + plateTail).toLocaleUpperCase(), [
      this.plateHead.toLocaleUpperCase(),
      plateTail
    ]);
    // }
  }

  @Watch('defaultValue')
  onDefaultValueChange(newVal: string, oldVal?: string) {
    const [plateHead, plateTail] = this.validateAndSplitPlate(newVal);
    this.plateHeadDefault = plateHead;
    this.plateTailDefault = plateTail;
    // 有默认值且无value值时赋值默认值
    if (newVal && this.plateHead == '' && this.plateTail == '') {
      this.plateHead = plateHead;
      this.plateTail = plateTail;
    }
  }

  /** 校验车牌号并塞值 */
  validateAndSplitPlate(value: string) {
    const plateHead = this.validatePlateHead(value[0]);
    const plateTail = this.validatePlateTail(plateHead ? value.substr(1) : value);
    // this.$emit('plateChange', [this.plateHead, this.plateTail], this.params)
    return [plateHead || this.plateHeadDefault, plateTail || this.plateTailDefault];
  }
  // 校验车牌省位
  validatePlateHead(value: string) {
    if (this.plateProvinceList.includes(value)) {
      return value;
    } else {
      return '';
    }
  }
  // 校验车牌除省位
  validatePlateTail(value: string) {
    return value
      .trim()
      .toLocaleUpperCase()
      .replace(/[^(0-9A-Z\u4e00-\u9fa5)]/g, '');
  }
}
